/* eslint-disable max-statements, no-console */
import { useEffect, useState } from "react"
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";

import Loader from "../../components/Loader";
import loginWithGoogle from "./loginWithGoogleToken";

const SignInGoogle = () => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const {
		mutateAsync: login
	} = loginWithGoogle(useMutation);

	const [loading, setLoading] = useState(true);

	useEffect(async () => {
		// Get the access_token from the url parameter.
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("access_token");

		if (token) {
			try {
				// Handle successful sign-in
				const user = await login({ token });
				await queryClient.setQueryData("auth-user", user);

				// Delete the token from local storage
				window.localStorage.removeItem("google_token");

				if (user?.weqProfileId) {
					navigate("/profile/dashboard");
				} else {
					navigate("/sign-up/questionnaire");
				}
			} catch (error) {
				// Handle sign-in error
				console.error("Sign-in error:", error);
				navigate("/sign-in");
			}
		} else {
			// Delete the token from local storage
			window.localStorage.removeItem("google_token");
			// Handle sign-in error
			navigate("/sign-in");

		}
		setLoading(false);
	}, []);

	return loading ? <Loader /> : null;
}

export default SignInGoogle;